export const countryLabels = {
  US: { primary: "US", secondary: "+1", demonym: "American" },
  GB: { primary: "GB", secondary: "+44", demonym: "British" },
  FR: { primary: "FR", secondary: "+33", demonym: "French" },
  DE: { primary: "DE", secondary: "+49", demonym: "German" },
  IT: { primary: "IT", secondary: "+39", demonym: "Italian" },
  ES: { primary: "ES", secondary: "+34", demonym: "Spanish" },
  CA: { primary: "CA", secondary: "+1", demonym: "Canadian" },
  AU: { primary: "AU", secondary: "+61", demonym: "Australian" },
  IN: { primary: "IN", secondary: "+91", demonym: "Indian" },
  CN: { primary: "CN", secondary: "+86", demonym: "Chinese" },
  JP: { primary: "JP", secondary: "+81", demonym: "Japanese" },
  KR: { primary: "KR", secondary: "+82", demonym: "Korean" },
  MX: { primary: "MX", secondary: "+52", demonym: "Mexican" },
  BR: { primary: "BR", secondary: "+55", demonym: "Brazilian" },
  ZA: { primary: "ZA", secondary: "+27", demonym: "South African" },
  RU: { primary: "RU", secondary: "+7", demonym: "Russian" },
  AR: { primary: "AR", secondary: "+54", demonym: "Argentine" },
  CL: { primary: "CL", secondary: "+56", demonym: "Chilean" },
  CO: { primary: "CO", secondary: "+57", demonym: "Colombian" },
  PE: { primary: "PE", secondary: "+51", demonym: "Peruvian" },
  VE: { primary: "VE", secondary: "+58", demonym: "Venezuelan" },
  NG: { primary: "NG", secondary: "+234", demonym: "Nigerian" },
  EG: { primary: "EG", secondary: "+20", demonym: "Egyptian" },
  MA: { primary: "MA", secondary: "+212", demonym: "Moroccan" },
  IL: { primary: "IL", secondary: "+972", demonym: "Israeli" },
  SA: { primary: "SA", secondary: "+966", demonym: "Saudi" },
  AT: { primary: "AT", secondary: "+43", demonym: "Austrian" },
  BE: { primary: "BE", secondary: "+32", demonym: "Belgian" },
  CH: { primary: "CH", secondary: "+41", demonym: "Swiss" },
  DK: { primary: "DK", secondary: "+45", demonym: "Danish" },
  FI: { primary: "FI", secondary: "+358", demonym: "Finnish" },
  GR: { primary: "GR", secondary: "+30", demonym: "Greek" },
  HU: { primary: "HU", secondary: "+36", demonym: "Hungarian" },
  IE: { primary: "IE", secondary: "+353", demonym: "Irish" },
  LT: { primary: "LT", secondary: "+370", demonym: "Lithuanian" },
  LV: { primary: "LV", secondary: "+371", demonym: "Latvian" },
  MT: { primary: "MT", secondary: "+356", demonym: "Maltese" },
  NL: { primary: "NL", secondary: "+31", demonym: "Dutch" },
  NO: { primary: "NO", secondary: "+47", demonym: "Norwegian" },
  PL: { primary: "PL", secondary: "+48", demonym: "Polish" },
  PT: { primary: "PT", secondary: "+351", demonym: "Portuguese" },
  SE: { primary: "SE", secondary: "+46", demonym: "Swedish" },
  SK: { primary: "SK", secondary: "+421", demonym: "Slovak" },
  SG: { primary: "SG", secondary: "+65", demonym: "Singaporean" },
  TH: { primary: "TH", secondary: "+66", demonym: "Thai" },
  TW: { primary: "TW", secondary: "+886", demonym: "Taiwanese" },
  VN: { primary: "VN", secondary: "+84", demonym: "Vietnamese" },
  ID: { primary: "ID", secondary: "+62", demonym: "Indonesian" },
  PK: { primary: "PK", secondary: "+92", demonym: "Pakistani" },
  BD: { primary: "BD", secondary: "+880", demonym: "Bangladeshi" },
  LK: { primary: "LK", secondary: "+94", demonym: "Sri Lankan" },
  PH: { primary: "PH", secondary: "+63", demonym: "Filipino" },
  MY: { primary: "MY", secondary: "+60", demonym: "Malaysian" },
  NZ: { primary: "NZ", secondary: "+64", demonym: "New Zealander" },
  FJ: { primary: "FJ", secondary: "+679", demonym: "Fijian" },
  WS: { primary: "WS", secondary: "+685", demonym: "Samoan" },
  TO: { primary: "TO", secondary: "+676", demonym: "Tongan" },
  TV: { primary: "TV", secondary: "+688", demonym: "Tuvaluan" },
  KW: { primary: "KW", secondary: "+965", demonym: "Kuwaiti" },
  LB: { primary: "LB", secondary: "+961", demonym: "Lebanese" },
  AF: { primary: "AF", secondary: "+93", demonym: "Afghan" },
  AL: { primary: "AL", secondary: "+355", demonym: "Albanian" },
  DZ: { primary: "DZ", secondary: "+213", demonym: "Algerian" },
  AS: { primary: "AS", secondary: "+1684", demonym: "American Samoan" },
  AD: { primary: "AD", secondary: "+376", demonym: "Andorran" },
  AO: { primary: "AO", secondary: "+244", demonym: "Angolan" },
  AI: { primary: "AI", secondary: "+1264", demonym: "Anguillan" },
  AG: { primary: "AG", secondary: "+1268", demonym: "Antiguan" },
  AM: { primary: "AM", secondary: "+374", demonym: "Armenian" },
  AW: { primary: "AW", secondary: "+297", demonym: "Aruban" },
  AZ: { primary: "AZ", secondary: "+994", demonym: "Azerbaijani" },
  BS: { primary: "BS", secondary: "+1242", demonym: "Bahamian" },
  BH: { primary: "BH", secondary: "+973", demonym: "Bahraini" },
  BB: { primary: "BB", secondary: "+1246", demonym: "Barbadian" },
  BY: { primary: "BY", secondary: "+375", demonym: "Belarusian" },
  BZ: { primary: "BZ", secondary: "+501", demonym: "Belizean" },
  BJ: { primary: "BJ", secondary: "+229", demonym: "Beninese" },
  BM: { primary: "BM", secondary: "+1441", demonym: "Bermudian" },
  BT: { primary: "BT", secondary: "+975", demonym: "Bhutanese" },
  BO: { primary: "BO", secondary: "+591", demonym: "Bolivian" },
  BA: { primary: "BA", secondary: "+387", demonym: "Bosnian" },
  BW: { primary: "BW", secondary: "+267", demonym: "Botswanan" },
  IO: {
    primary: "IO",
    secondary: "+246",
    demonym: "British Indian Ocean Territory",
  },
  VG: { primary: "VG", secondary: "+1284", demonym: "British Virgin Islander" },
  BN: { primary: "BN", secondary: "+673", demonym: "Bruneian" },
  BG: { primary: "BG", secondary: "+359", demonym: "Bulgarian" },
  BF: { primary: "BF", secondary: "+226", demonym: "Burkinabé" },
  BI: { primary: "BI", secondary: "+257", demonym: "Burundian" },
  KH: { primary: "KH", secondary: "+855", demonym: "Cambodian" },
  CM: { primary: "CM", secondary: "+237", demonym: "Cameroonian" },
  CV: { primary: "CV", secondary: "+238", demonym: "Cape Verdean" },
  BQ: { primary: "BQ", secondary: "+599", demonym: "Caribbean Netherlander" },
  KY: { primary: "KY", secondary: "+1345", demonym: "Caymanian" },
  CF: { primary: "CF", secondary: "+236", demonym: "Central African" },
  TD: { primary: "TD", secondary: "+235", demonym: "Chadian" },
  CX: { primary: "CX", secondary: "+61", demonym: "Christmas Islander" },
  CC: { primary: "CC", secondary: "+61", demonym: "Cocos Islander" },
  KM: { primary: "KM", secondary: "+269", demonym: "Comorian" },
  CD: { primary: "CD", secondary: "+243", demonym: "Congolese" },
  CG: { primary: "CG", secondary: "+242", demonym: "Congolese" },
  CK: { primary: "CK", secondary: "+682", demonym: "Cook Islander" },
  CR: { primary: "CR", secondary: "+506", demonym: "Costa Rican" },
  CI: { primary: "CI", secondary: "+225", demonym: "Ivorian" },
  HR: { primary: "HR", secondary: "+385", demonym: "Croatian" },
  CU: { primary: "CU", secondary: "+53", demonym: "Cuban" },
  CW: { primary: "CW", secondary: "+599", demonym: "Curaçaoan" },
  CY: { primary: "CY", secondary: "+357", demonym: "Cypriot" },
  CZ: { primary: "CZ", secondary: "+420", demonym: "Czech" },
  DJ: { primary: "DJ", secondary: "+253", demonym: "Djiboutian" },
  DM: { primary: "DM", secondary: "+1767", demonym: "Dominican" },
  DO: { primary: "DO", secondary: "+1", demonym: "Dominican" },
  EC: { primary: "EC", secondary: "+593", demonym: "Ecuadorian" },
  SV: { primary: "SV", secondary: "+503", demonym: "Salvadoran" },
  GQ: { primary: "GQ", secondary: "+240", demonym: "Equatorial Guinean" },
  ER: { primary: "ER", secondary: "+291", demonym: "Eritrean" },
  EE: { primary: "EE", secondary: "+372", demonym: "Estonian" },
  ET: { primary: "ET", secondary: "+251", demonym: "Ethiopian" },
  FK: { primary: "FK", secondary: "+500", demonym: "Falkland Islander" },
  FO: { primary: "FO", secondary: "+298", demonym: "Faroese" },
  GF: { primary: "GF", secondary: "+594", demonym: "French Guianese" },
  PF: { primary: "PF", secondary: "+689", demonym: "French Polynesian" },
  GA: { primary: "GA", secondary: "+241", demonym: "Gabonese" },
  GM: { primary: "GM", secondary: "+220", demonym: "Gambian" },
  GE: { primary: "GE", secondary: "+995", demonym: "Georgian" },
  GH: { primary: "GH", secondary: "+233", demonym: "Ghanaian" },
  GI: { primary: "GI", secondary: "+350", demonym: "Gibraltarian" },
  GL: { primary: "GL", secondary: "+299", demonym: "Greenlandic" },
  GD: { primary: "GD", secondary: "+1473", demonym: "Grenadian" },
  GP: { primary: "GP", secondary: "+590", demonym: "Guadeloupean" },
  GU: { primary: "GU", secondary: "+1671", demonym: "Guamanian" },
  GT: { primary: "GT", secondary: "+502", demonym: "Guatemalan" },
  GG: { primary: "GG", secondary: "+44", demonym: "Guernseyan" },
  GN: { primary: "GN", secondary: "+224", demonym: "Guinean" },
  GW: { primary: "GW", secondary: "+245", demonym: "Guinea-Bissauan" },
  GY: { primary: "GY", secondary: "+592", demonym: "Guyanese" },
  HT: { primary: "HT", secondary: "+509", demonym: "Haitian" },
  HN: { primary: "HN", secondary: "+504", demonym: "Honduran" },
  HK: { primary: "HK", secondary: "+852", demonym: "Hong Konger" },
  IS: { primary: "IS", secondary: "+354", demonym: "Icelandic" },
  IR: { primary: "IR", secondary: "+98", demonym: "Iranian" },
  IQ: { primary: "IQ", secondary: "+964", demonym: "Iraqi" },
  IM: { primary: "IM", secondary: "+44", demonym: "Manx" },
  JM: { primary: "JM", secondary: "+1876", demonym: "Jamaican" },
  JE: { primary: "JE", secondary: "+44", demonym: "Jersey" },
  JO: { primary: "JO", secondary: "+962", demonym: "Jordanian" },
  KZ: { primary: "KZ", secondary: "+7", demonym: "Kazakhstani" },
  KE: { primary: "KE", secondary: "+254", demonym: "Kenyan" },
  KI: { primary: "KI", secondary: "+686", demonym: "I-Kiribati" },
  XK: { primary: "XK", secondary: "+383", demonym: "Kosovar" },
  KG: { primary: "KG", secondary: "+996", demonym: "Kyrgyzstani" },
  LA: { primary: "LA", secondary: "+856", demonym: "Laotian" },
  LS: { primary: "LS", secondary: "+266", demonym: "Lesothan" },
  LR: { primary: "LR", secondary: "+231", demonym: "Liberian" },
  LY: { primary: "LY", secondary: "+218", demonym: "Libyan" },
  LI: { primary: "LI", secondary: "+423", demonym: "Liechtensteiner" },
  LU: { primary: "LU", secondary: "+352", demonym: "Luxembourgish" },
  MO: { primary: "MO", secondary: "+853", demonym: "Macanese" },
  MK: { primary: "MK", secondary: "+389", demonym: "Macedonian" },
  MG: { primary: "MG", secondary: "+261", demonym: "Malagasy" },
  MW: { primary: "MW", secondary: "+265", demonym: "Malawian" },
  MV: { primary: "MV", secondary: "+960", demonym: "Maldivian" },
  ML: { primary: "ML", secondary: "+223", demonym: "Malian" },
  MH: { primary: "MH", secondary: "+692", demonym: "Marshallese" },
  MQ: { primary: "MQ", secondary: "+596", demonym: "Martinican" },
  MR: { primary: "MR", secondary: "+222", demonym: "Mauritanian" },
  MU: { primary: "MU", secondary: "+230", demonym: "Mauritian" },
  YT: { primary: "YT", secondary: "+262", demonym: "Mahoran" },
  FM: { primary: "FM", secondary: "+691", demonym: "Micronesian" },
  MD: { primary: "MD", secondary: "+373", demonym: "Moldovan" },
  MC: { primary: "MC", secondary: "+377", demonym: "Monacan" },
  MN: { primary: "MN", secondary: "+976", demonym: "Mongolian" },
  ME: { primary: "ME", secondary: "+382", demonym: "Montenegrin" },
  MS: { primary: "MS", secondary: "+1664", demonym: "Montserratian" },
  MZ: { primary: "MZ", secondary: "+258", demonym: "Mozambican" },
  MM: { primary: "MM", secondary: "+95", demonym: "Burmese" },
  NA: { primary: "NA", secondary: "+264", demonym: "Namibian" },
  NR: { primary: "NR", secondary: "+674", demonym: "Nauruan" },
  NP: { primary: "NP", secondary: "+977", demonym: "Nepalese" },
  NC: { primary: "NC", secondary: "+687", demonym: "New Caledonian" },
  NI: { primary: "NI", secondary: "+505", demonym: "Nicaraguan" },
  NE: { primary: "NE", secondary: "+227", demonym: "Nigerien" },
  NU: { primary: "NU", secondary: "+683", demonym: "Niuean" },
  NF: { primary: "NF", secondary: "+672", demonym: "Norfolk Islander" },
  KP: { primary: "KP", secondary: "+850", demonym: "North Korean" },
  MP: {
    primary: "MP",
    secondary: "+1670",
    demonym: "Northern Mariana Islander",
  },
  OM: { primary: "OM", secondary: "+968", demonym: "Omani" },
  PW: { primary: "PW", secondary: "+680", demonym: "Palauan" },
  PS: { primary: "PS", secondary: "+970", demonym: "Palestinian" },
  PA: { primary: "PA", secondary: "+507", demonym: "Panamanian" },
  PG: { primary: "PG", secondary: "+675", demonym: "Papua New Guinean" },
  PY: { primary: "PY", secondary: "+595", demonym: "Paraguayan" },
  PR: { primary: "PR", secondary: "+1", demonym: "Puerto Rican" },
  QA: { primary: "QA", secondary: "+974", demonym: "Qatari" },
  RE: { primary: "RE", secondary: "+262", demonym: "Réunionese" },
  RO: { primary: "RO", secondary: "+40", demonym: "Romanian" },
  RW: { primary: "RW", secondary: "+250", demonym: "Rwandan" },
  BL: {
    primary: "BL",
    secondary: "+590",
    demonym: "Saint Barthélemy Islander",
  },
  SH: { primary: "SH", secondary: "+290", demonym: "Saint Helenian" },
  KN: { primary: "KN", secondary: "+1869", demonym: "Kittitian" },
  LC: { primary: "LC", secondary: "+1758", demonym: "Saint Lucian" },
  MF: { primary: "MF", secondary: "+590", demonym: "Saint Martin Islander" },
  PM: { primary: "PM", secondary: "+508", demonym: "Saint-Pierrais" },
  VC: { primary: "VC", secondary: "+1784", demonym: "Saint Vincentian" },
  SM: { primary: "SM", secondary: "+378", demonym: "Sammarinese" },
  ST: { primary: "ST", secondary: "+239", demonym: "São Toméan" },
  SN: { primary: "SN", secondary: "+221", demonym: "Senegalese" },
  RS: { primary: "RS", secondary: "+381", demonym: "Serbian" },
  SC: { primary: "SC", secondary: "+248", demonym: "Seychellois" },
  SL: { primary: "SL", secondary: "+232", demonym: "Sierra Leonean" },
  SX: { primary: "SX", secondary: "+1721", demonym: "Sint Maartener" },
  SI: { primary: "SI", secondary: "+386", demonym: "Slovenian" },
  SB: { primary: "SB", secondary: "+677", demonym: "Solomon Islander" },
  SO: { primary: "SO", secondary: "+252", demonym: "Somali" },
  SS: { primary: "SS", secondary: "+211", demonym: "South Sudanese" },
  SD: { primary: "SD", secondary: "+249", demonym: "Sudanese" },
  SR: { primary: "SR", secondary: "+597", demonym: "Surinamese" },
  SJ: { primary: "SJ", secondary: "+47", demonym: "Svalbard Islander" },
  SZ: { primary: "SZ", secondary: "+268", demonym: "Swazi" },
  SY: { primary: "SY", secondary: "+963", demonym: "Syrian" },
  TJ: { primary: "TJ", secondary: "+992", demonym: "Tajikistani" },
  TZ: { primary: "TZ", secondary: "+255", demonym: "Tanzanian" },
  TL: { primary: "TL", secondary: "+670", demonym: "Timorese" },
  TG: { primary: "TG", secondary: "+228", demonym: "Togolese" },
  TK: { primary: "TK", secondary: "+690", demonym: "Tokelauan" },
  TT: { primary: "TT", secondary: "+1868", demonym: "Trinidadian" },
  TN: { primary: "TN", secondary: "+216", demonym: "Tunisian" },
  TR: { primary: "TR", secondary: "+90", demonym: "Turkish" },
  TM: { primary: "TM", secondary: "+993", demonym: "Turkmen" },
  TC: {
    primary: "TC",
    secondary: "+1649",
    demonym: "Turks and Caicos Islander",
  },
  VI: { primary: "VI", secondary: "+1340", demonym: "Virgin Islander" },
  UG: { primary: "UG", secondary: "+256", demonym: "Ugandan" },
  UA: { primary: "UA", secondary: "+380", demonym: "Ukrainian" },
  AE: { primary: "AE", secondary: "+971", demonym: "Emirati" },
  UY: { primary: "UY", secondary: "+598", demonym: "Uruguayan" },
  UZ: { primary: "UZ", secondary: "+998", demonym: "Uzbekistani" },
  VU: { primary: "VU", secondary: "+678", demonym: "Vanuatuan" },
  VA: { primary: "VA", secondary: "+39", demonym: "Vatican" },
  WF: { primary: "WF", secondary: "+681", demonym: "Wallisian" },
  EH: { primary: "EH", secondary: "+212", demonym: "Sahrawi" },
  YE: { primary: "YE", secondary: "+967", demonym: "Yemeni" },
  ZM: { primary: "ZM", secondary: "+260", demonym: "Zambian" },
  ZW: { primary: "ZW", secondary: "+263", demonym: "Zimbabwean" },
  AX: { primary: "AX", secondary: "+358", demonym: "Ålandic" },
};
